import React from 'react';

import { Box, BoxProps } from '@chakra-ui/react';

import { Footer } from '../Footer/Footer';
import { Navigation } from '../Navigation/Navigation';

interface LayoutProps extends BoxProps {
	as?: React.ElementType;
	showContactSectionInFooter?: boolean;
	children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({
	as = 'main',
	showContactSectionInFooter = true,
	children,
	...rest
}) => {
	return (
		<div className="flex min-h-screen flex-col">
			<Box zIndex={99} position="sticky" top={0}>
				<Navigation />
			</Box>
			<Box as={as} pt={28} className="grow" {...rest}>
				{children}
			</Box>
			<Footer showContactSection={showContactSectionInFooter} />
		</div>
	);
};
